import Swiper from 'swiper/bundle'

window.customElements.define('shop-by-breed', class ShopByBreed extends HTMLElement {
  connectedCallback() {
    const select = this.querySelector('.shop-by-breed__select')
    const carousel = this.querySelector('.shop-by-breed__carousel')

    if (!carousel) return

    this.swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: {
        el: this.querySelector('.shop-by-breed__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.shop-by-breed__next'),
        prevEl: this.querySelector('.shop-by-breed__previous'),
      },
      breakpoints: {
        768: { slidesPerView: 'auto', spaceBetween: 16 },
        1024: { slidesPerView: 'auto', spaceBetween: 16 },
      },
    })

    if (select) {
      select.addEventListener('change', () => {
        if (select.value !== '') this.swiper.slideTo(Number(select.value))
      })
    }
  }

  disconnectedCallback() {
    this.swiper?.destroy()
  }
})